import { APIClient } from "@frontend/api-utils";

export class IoTHealthClient extends APIClient {
    public static readonly endpoint = '/iot-api';

    public static async checkHealth(): Promise<boolean> {
        const response = await this.fetch(`${this.endpoint}/health-check`, undefined, false);
        return await this.handleResponse<boolean>(response);
    }
}